import { ChainId } from '@src/configs/chainInfo'
import { supportedChains } from '@src/configs/supportedChains'

export const getBlockExplorerUrlFromChainId = (chainId: string | number) => {
    if (Number(chainId) === ChainId.Solana) {
        return 'https://solscan.io/tx'
    } else if (Number(chainId) === ChainId.Tron) {
        // tron
        return 'https://tronscan.org/#/transaction'
    } else if (Number(chainId) === ChainId.MonadTestnet) {
        return 'https://testnet.monadexplorer.com/tx'
    }
    const chainInfo = supportedChains.find(chain => +chain.id === +chainId)
    return `${chainInfo?.blockExplorers?.['default']?.url || ''}/tx`
}
